<!-- 条线管理 -->
<template>
  <a-card :bordered="false">
    <a-row>
      <a-col :sm="24" :md="24" :lg="18" :xl="14" :xxl="10">
        <a-button type="primary" icon="check" @click="handleSave">保存</a-button>

        <a-descriptions class="no-label" style="margin-top: 0px; margin-bottom: 0">
          <a-descriptions-item>
            <a-form-model ref="form" :model="form" :rules="rules">
              <a-table
                rowKey="sort"
                tableLayout="fixed"
                :pagination="false"
                bordered
                :dataSource="form.sysBizLines"
                :loading="loading"
              >
                <a-table-column key="index" title="#" :width="47" align="center">
                  <template slot-scope="text, record, index">
                    {{ parseInt(index) + 1 }}
                  </template>
                </a-table-column>

                <a-table-column key="bizLineName" data-index="bizLineName">
                  <span slot="title" :class="$isRequired('bizLineName')">条线名称</span>
                  <template slot-scope="text, record, index">
                    <a-form-model-item :prop="`sysBizLines.${index}.bizLineName`" :rules="rules.bizLineName">
                      <a-input v-model="record.bizLineName" placeholder="请填写" :maxLength="100"></a-input>
                    </a-form-model-item>
                  </template>
                </a-table-column>

                <a-table-column key="bizLineSupervisorId" data-index="bizLineSupervisorId">
                  <span slot="title" :class="$isRequired('bizLineSupervisorId')">条线负责人</span>
                  <template slot-scope="text, record, index">
                    <a-form-model-item
                      :prop="`sysBizLines.${index}.bizLineSupervisorId`"
                      :rules="rules.bizLineSupervisorId"
                    >
                      <j-input-popup
                        v-model="record.bizLineSupervisor"
                        placeholder="请选择"
                        component="SelectUserTreeModal"
                        :params="{
                          multiFlg: '0',
                          departFlg: '1',
                          selectUserList: record.bizLineSupervisor,
                        }"
                        @change="changeBizLineSupervisor(arguments, record)"
                      ></j-input-popup>
                    </a-form-model-item>
                  </template>
                </a-table-column>

                <a-table-column key="note" data-index="note" width="35%">
                  <span slot="title">备注</span>
                  <template slot-scope="text, record, index">
                    <a-form-model-item :prop="`sysBizLines.${index}.note`">
                      <a-input v-model="record.note" placeholder="请填写" :maxLength="1000"></a-input>
                    </a-form-model-item>
                  </template>
                </a-table-column>

                <a-table-column :width="85" align="center">
                  <span slot="title">
                    <i class="mdi mdi-plus" @click="addRow(form.sysBizLines)"></i>
                  </span>
                  <div slot-scope="text, record, index" style="white-space: nowrap;">
                    <JSort></JSort>

                    <a-divider type="vertical" />

                    <a @click="deleteRow(form.sysBizLines, index)">删除</a>
                  </div>
                </a-table-column>
              </a-table>
            </a-form-model>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { putAction, postAction, getAction } from '@/api/manage'
import { tableMixin } from '@/mixins/tableMixin'

class formDef {
  sysBizLines = []
}

export default {
  name: 'BizLineManage',
  mixins: [tableMixin],
  components: {},
  props: {},
  data() {
    return {
      form: new formDef(),
      loading: false,
      checkedKeys: [],
      url: {
        list: '/blaze-sys/BizLineManage/list',
        save: '/blaze-sys/BizLineManage/save',
      },
      rules: {
        bizLineName: [
          this._r.required,
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (XEUtils.filter(this.form.sysBizLines, (row) => row.bizLineName == value).length > 1) {
                  callback('已有相同条线')
                } else {
                  callback()
                }
              } else {
                callback('请填写必须项目')
              }
            },
          },
        ],
        bizLineSupervisorId: [this._r.required],
      },
    }
  },
  created() {},
  mounted() {
    this.enableMoveRow((newIndex, oldIndex) => {
      const currRow = this.form.sysBizLines.splice(oldIndex, 1)[0]
      this.form.sysBizLines.splice(newIndex, 0, currRow)
    })
  },
  methods: {
    callbackAfterSearchQuery(records) {
      this.form.sysBizLines = records

      this.form.sysBizLines.forEach((r, index) => {
        r.bizLineSupervisor = []
        r.bizLineSupervisor.push({
          value: r.bizLineSupervisorId,
          text: r.bizLineSupervisorName,
        })
      })

      this.$forceUpdate()
    },
    addRow() {
      this.form.sysBizLines.push({
        id: undefined,
        bizLineName: undefined,
        bizLineSupervisor: undefined,
        bizLineSupervisorId: undefined,
        bizLineSupervisorName: undefined,
        sort: new Date().getTime(),
        note: undefined,
      })
    },
    changeBizLineSupervisor(arg, record) {
      if (arg[0].length > 0) {
        record.bizLineSupervisorId = arg[0][0].id
        record.bizLineSupervisorName = arg[0][0].realname
      } else {
        record.bizLineSupervisorId = undefined
        record.bizLineSupervisorName = undefined
      }
    },
    handleSave() {
      this.$refs.form.validateFieldsAndScroll((ok) => {
        if (ok) {
          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          // 设置sort
          this.form.sysBizLines.forEach((element, index) => {
            element.sort = index
          })

          postAction(this.url.save, this.form.sysBizLines)
            .then((res) => {
              if (res.success) {
                this.$message.success('处理成功')
                this.searchQuery(false, false)
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
</style>
